import { atom, selector } from "recoil";

export const authorizedState = atom({
  key: "authorizedState",
  default: false,
});

export const searchValueState = atom({
  key: "searchValueState",
  default: "",
});

export const loginModalState = atom({
  key: "loginModalState",
  default: {
    isVisible: false,
    redirectAfterLogin: null,
  },
});

export const registerModalState = atom({
  key: "registerModalState",
  default: {
    isVisible: false,
    redirectAfterLogin: null,
  },
});

export const cartState = atom({
  key: "cartState",
  default: [],
});

export const cartItemCountState = selector({
  key: "cartItemCountState",
  get: ({ get }) => {
    const basket = get(cartState);
    return basket.reduce((sum, item) => sum + item.quantity, 0);
  },
});
